// extracted by mini-css-extract-plugin
export var askAiIcon = "_mb-j";
export var category = "_mb-9";
export var categoryHeader = "_mb-e";
export var container = "_mb-0";
export var group = "_mb-a";
export var groupItems = "_mb-f";
export var groupSeparator = "_mb-k";
export var loading = "_mb-1";
export var noResults = "_mb-3";
export var placeholder = "_mb-2";
export var resultContent = "_mb-5";
export var resultIcon = "_mb-c";
export var resultItem = "_mb-g";
export var resultMeta = "_mb-8";
export var resultSubtitle = "_mb-7";
export var resultSuffix = "_mb-i";
export var resultTitle = "_mb-6";
export var resultsList = "_mb-4";
export var searchGroup = "_mb-d";
export var selected = "_mb-h";
export var subgroup = "_mb-b";